export default __webpack_public_path__ + "static/media/about-us.0185e1d2.jpg";